import React, { useState, useEffect } from 'react';
import { IconButton, Tooltip, Box } from "@mui/material";
import EditDocumentIcon from '@mui/icons-material/EditDocument';
import DeleteIcon from "@mui/icons-material/Delete";
export interface CardActionProps {
    onRemove: () => void;
    onEdit: () => void;
    artworkCount: number;
}

const CardButtons: React.FC<CardActionProps> = ({ onRemove, onEdit, artworkCount }) => {
    
    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1 }}>
                <Tooltip title="Edit artist details">
                    <IconButton edge="end" onClick={onEdit}>
                        <EditDocumentIcon />
                    </IconButton>
                </Tooltip>

                {artworkCount === 0 && (
                    <Tooltip title="Remove artist">
                        <IconButton edge="end" onClick={onRemove}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
        </>

    )
};

export default CardButtons;